<template lang="pug">
  content-page
    div(slot="nav")
      navigation-default

    div(slot="sidebar")
      ad

    h1 {{contentpage.name}}
    ws-content(:value="contentpage.content")
      div(v-if="offers.length")
        v-card( v-for="(offer, index) in offers" tag="v-card" flat :key="offer.id")
          a.d-block(:href="`/redir?u=${encodeURIComponent(offer.url)}&p=${offer.partner.slug}&i=${offer.id}&t=offer&h=${$redirHash(offer.url)}`" rel="nofollow"  target="_blank")
            v-row
              v-col.shrink.pr-3
                v-sheet.counter(tile) {{index + 1}}
              v-col.shrink.pr-3
                v-img(:src="`${offer.image}?width=160`" width="140" :aspect-ratio="16/9")
              v-col(grow)
                h2 {{offer.name}}
                v-img.mt-3(:src="`${offer.partner.image}?width=160`" :alt="offer.partner.name" width="60")
              v-col.shrink.text-center
                .caption.grey--text {{offer.prefix}}
                .headline.error--text {{offer.offer}}
                v-btn(outlined color="primary" small) meer info
            v-divider.mt-2.mb-4

</template>

<style lang="sass" scoped>
.counter
	width: 38px
	height: 38px
	vertical-align: middle
	line-height: 38px
	text-align: center
	background-color: var(--v-border-lighten1)
	font-size: 18px
</style>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import NavigationDefault from '@/components/navigation-default';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const query = gql`
	query getOfferPage($slug: String!) {
		contentpage(slug: $slug) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		offers {
			id
			name
			url
			offer
			prefix
			image
			partner {
				id
				name
				slug
				image
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/aanbiedingen',
			'de-DE': '/angebote-skiurlaub',
			'nl-BE': '/aanbiedingen'
		}
	},
	components: { NavigationDefault },
	asyncData({ _params, app, route }) {
		app.ads({});
		return app.$graphClient
			.query({
				query,
				variables: {
					slug: route.path.split('/').pop()
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.breadcrumbs({
					[data.contentpage.name]: { name: 'offers' }
				});
				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'offers-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
